import React, { useEffect, useMemo, useState } from "react";
import Page from "components/Page";
import Card from "components/Card";
import Input from "components/Input";
import Text from "components/Text";
import CustomDropdown from "components/Dropdown";
import moment from "moment";
import { Portal } from "react-overlays";
import { withTranslation } from "react-i18next";
import AssignStaffMembersModal from "../Modals/AssignStaffMembersModal";
import { useAddTaskController } from "../hooks/useAddTaskController";
import Loader from "components/Loader";
import DeleteIcon from "../../../../assets/images/delete-red.svg";
import "../TaskManagement.scss";
import styles from "../TaskManagement.module.scss";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const AddNewNote = ({
  t,
  history,
  isInsideModal,
  editTaskId,
  closeModalHandler,
}) => {
  const {
    data: {
      isModalOpen,
      isAnyLoading,
      formData,
      priority,
      prioritiesOptions,
      dates,
      errors,
      OptionsStaff,
      fileNames,
      staffSelectedCount,
      selectedOption,
      selectedStaff,
      taskId,
    },
    methods: {
      handleOnChange,
      setPriority,
      updateDatesValues,
      handleSubmit,
      handleToggle,
      handleApplyCheck,
      handleCheckboxChange,
      handleFileChange,
      handleCancelCheck,
      onBack,
      setSelectedOption,
      handleRemoveFile,
      isValidEvent,
    },
  } = useAddTaskController({
    t,
    history,
    addTask: true,
    editTaskId,
    isInsideModal,
    closeModalHandler,
  });
  const [OfficeOptions, setOfficeOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);

  const { borderButtons, highlightedButton, classAdd } = useMemo(
    () => ({
      highlightedButton:
        "button button-round button-shadow mr-md-4 mb-3 w-sm-100",
      borderButtons:
        "mb-md-3 button button-round button-border btn-mobile-link button-dark",
      classAdd: isInsideModal
        ? " bg-transparent border border-0 shadow-none"
        : "",
    }),
    []
  );

  const ConverOptions = (staffOptions) => {
    let newOtion = { value: "all_offices", label: "All Offices" };
    const uniqueLabels = new Set();
    let uniqueOffice = staffOptions
      .filter((office) => {
        if (uniqueLabels.has(office?.officeId)) {
          return false;
        }
        uniqueLabels.add(office?.officeId);
        return true;
      })
      .map((office) => ({ value: office?.officeId, label: office.officeName }));
    let updateUniqueOffice = [newOtion, ...uniqueOffice];
    setOfficeOptions(updateUniqueOffice);
  };

  useEffect(() => {
    setStaffOptions(OptionsStaff);
  }, [OptionsStaff]);

  useEffect(() => {
    ConverOptions(OptionsStaff);
  }, [isModalOpen, OptionsStaff]);

  const handleRequestStatusFilter = (selectedOffice) => {
    setSelectedOption(selectedOffice);
    if (selectedOffice?.value === "all_offices") {
      let FilterData = OptionsStaff?.filter((office) => office);
      setStaffOptions(FilterData);
    } else {
      let FilterData = OptionsStaff?.filter(
        (office) => office?.officeId === selectedOffice.value
      );
      setStaffOptions(FilterData);
    }
  };

  const getMemberText = (count) => {
    if (count === 0) {
      return t("taskManagement.noMember");
    }
    return `${count} ${
      count === 1 ? t("taskManagement.member") : t("taskManagement.member")
    }`;
  };

  const otherElements = (
    <>
      {isAnyLoading && <Loader />}
      <form
        onSubmit={handleSubmit}
        className={
          isInsideModal && isModalOpen
            ? "d-none"
            : "w-100 form-wrapper p-0" + classAdd
        }
      >
        <Card
          className={
            isInsideModal ? "p-0" + classAdd : styles.add_new_note_card_wrapper
          }
        >
          <div className={styles["add_new_note_parent_wrapper"]}>
            <Input
              Title={t("title")}
              Type="text"
              Placeholder={t("taskManagement.enterTitle")}
              Name={"title"}
              HandleChange={handleOnChange}
              Error={errors.title}
              Value={formData?.title}
              MaxLength="35"
            />
            <div className="c-field">
              <label>{t("taskManagement.taskDescrition")}</label>
              <textarea
                className="c-form-control"
                Placeholder={t("taskManagement.enterDescription")}
                name="description"
                maxLength="400"
                onChange={handleOnChange}
                error={errors.description}
                value={formData?.description}
              ></textarea>
              {errors.description && (
                <span className="error-msg">{errors.description}</span>
              )}
            </div>
            <div className={styles["date_wrapper"] + " c-field mb-0"}>
              <div className={styles.new_inputdate + " inputdate"}>
                <Text size="13px" weight="400" color="#79869A">
                  {t("superAdminVendorManagement.startDate")}
                </Text>
                <ReactDatePickerCommon
                  dateFormat="dd-MM-yyyy"
                  className="c-form-control"
                  selected={dates.startDate}
                  onChange={(e) => updateDatesValues(e, "startDate")}
                  popperPlacement="bottom-start"
                  popperContainer={CalendarContainer}
                  openToDate={moment().toDate()}
                  minDate={moment().toDate()}
                  maxDate={!taskId && dates?.DueDate}
                />
                {errors.startDate && (
                  <span className="error-msg">{errors.startDate}</span>
                )}
              </div>
              <div
                className={
                  styles.new_inputdate +
                  " inputdate" +
                  (isInsideModal ? " mt-3" : "")
                }
              >
                <Text size="13px" weight="400" color="#79869A">
                  {t("taskManagement.dueDate")}
                </Text>
                <ReactDatePickerCommon
                  dateFormat="dd-MM-yyyy"
                  className="c-form-control"
                  selected={dates.DueDate}
                  onChange={(e) => updateDatesValues(e, "DueDate")}
                  popperPlacement="bottom-start"
                  popperContainer={CalendarContainer}
                  openToDate={moment().toDate()}
                  minDate={moment().toDate()}
                />
                {errors.DueDate && (
                  <span className="error-msg">{errors.DueDate}</span>
                )}
              </div>
            </div>
            <div className="c-field">
              <Text size="13px" weight="400" color="#79869A" marginTop="30px">
                {t("taskManagement.priority")}
              </Text>
              <div className="custom-dropdown-only">
                <CustomDropdown
                  options={prioritiesOptions}
                  selectedOption={priority}
                  selectOption={(id) => {
                    setPriority(id);
                  }}
                />
              </div>
            </div>
            {!isInsideModal && (
              <div className={styles["assiness_input"]}>
                <div className="d-flex justify-content-between">
                  <Text size="13px" weight="400" color="#79869A">
                    {t("taskManagement.assignees")}
                  </Text>
                  <p
                    className="link-btn m-0"
                    onClick={() => {
                      handleToggle();
                    }}
                  >
                    {staffSelectedCount == 0
                      ? t("taskManagement.assginStaffMemeber")
                      : t("taskManagement.add")}
                  </p>
                </div>
                <Text size="14px" weight="600" color="#102C42" marginTop="8px">
                  {getMemberText(staffSelectedCount)}
                </Text>
                {errors.staffSelection && (
                  <span className="error-msg">{errors.staffSelection}</span>
                )}
              </div>
            )}
            <input
              name="uploadFile"
              type="file"
              id="fileInput"
              style={{ display: "none" }}
              onChange={handleFileChange}
              multiple
            />
            <div className={styles["heading-data-Wrapper"]}>
              <div className={styles["head-link-wrapper"]}>
                <div className={styles["appointment-head"]}>
                  {t("notes.attachment")}
                </div>
                <label
                  htmlFor="fileInput"
                  className={styles["appointment-link"]}
                >
                  {t("notes.uploadFile")}
                </label>
              </div>
              <div className={styles["file_upload_wrapper"]}>
                <div>
                  {fileNames.length === 0 ? (
                    <div className={styles["appointment-text"]}>
                      {t("notes.noAttachments")}
                    </div>
                  ) : (
                    <ul className={styles.task_edit_attachment_list}>
                      {fileNames
                        .filter((file) => !file.IsDeleted)
                        .map((file, idx) => {
                          const path =
                            typeof file.path === "string" ? file.path : "";
                          const isApiFile =
                            !file.file &&
                            path &&
                            (path.startsWith("http") ||
                              path.startsWith("globalnotesattachments/"));
                          const fileUrl = path
                            ? path.startsWith("http")
                              ? path
                              : `https://${process.env.REACT_APP_AZURE_STORAGE_ACCOUNT}.blob.core.windows.net/${path}`
                            : "#";
                          const fileNameDisplay =
                            file.file?.name ||
                            (path ? path.split("/").pop() : "Unknown file");

                          return (
                            <li
                              key={idx}
                              className={styles.task_edit_attachment_row}
                            >
                              {isApiFile ? (
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={styles.task_edit_attachment_name}
                                >
                                  {fileNameDisplay}
                                </a>
                              ) : (
                                <span className={styles.task_edit_attachment_name}>
                                  {fileNameDisplay}
                                </span>
                              )}
                              <span className={styles.task_edit_attachment_delete}>
                                <img
                                  src={DeleteIcon}
                                  alt="DeleteIcon"
                                  className={styles["trash_image"]}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleRemoveFile(idx)}
                                />
                              </span>
                            </li>
                          );
                        })}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <div
              className={
                styles["checkbox_wrapper_one"] +
                (isInsideModal ? " d-flex flex-column gap-md my-3" : "")
              }
            >
              <div
                className={
                  styles["check_box_width"] +
                  " ch-checkbox c-field all-event-checkbox m-0"
                }
              >
                <label>
                  <input
                    type="checkbox"
                    name="notifyAssignees"
                    checked={formData?.notifyAssignees}
                    onChange={handleOnChange}
                  />
                  <span>{t("taskManagement.notifyAssigneesabouttheTask")}</span>
                </label>
              </div>
              <div
                className={
                  styles["check_box_width"] +
                  " " +
                  "ch-checkbox c-field all-event-checkbox m-0"
                }
              >
                <label>
                  <input
                    type="checkbox"
                    name="notifyAssignor"
                    checked={formData?.notifyAssignor}
                    onChange={handleOnChange}
                  />
                  <span>
                    {t("taskManagement.notifyAssigneesabouttheUpdates")}
                  </span>
                </label>
              </div>
            </div>
            {isInsideModal ? (
              <div
                className={
                  styles["btn_wrapper"] +
                  ` d-flex justify-content-${isModalOpen ? " between" : "end"}`
                }
              >
                <button
                  className={highlightedButton.replace(" mr-md-4 mb-3", "")}
                  title="cancel"
                  onClick={() => {
                    if (!isModalOpen && isValidEvent(true)) {
                      handleToggle();
                    }
                  }}
                  type="button"
                >
                  {t("notes.nextStep")}
                </button>
              </div>
            ) : (
              <div className={styles["btn_wrapper"]}>
                <button
                  className={highlightedButton}
                  title="save"
                  type="submit"
                >
                  {taskId
                    ? t("taskManagement.update")
                    : t("taskManagement.addNewTask")}
                </button>
                <button
                  className={borderButtons}
                  title="cancel"
                  onClick={() => onBack()}
                >
                  {t("taskManagement.cancel")}
                </button>
              </div>
            )}
          </div>
        </Card>
      </form>
      {isModalOpen && (
        <AssignStaffMembersModal
          isModalOpen={true}
          closeModal={handleToggle}
          options={OfficeOptions}
          isInsideModal={isInsideModal}
          selectedOption={selectedOption}
          handleRequestStatusFilter={handleRequestStatusFilter}
          OptionsStaff={staffOptions}
          handleCheckboxChange={handleCheckboxChange}
          handleApplyCheck={handleApplyCheck}
          handleCancelCheck={handleCancelCheck}
          selectedStaff={selectedStaff}
          taskId={taskId}
        />
      )}
    </>
  );
  if (isInsideModal) {
    return otherElements;
  }
  return (
    <Page
      onBack={onBack}
      title={
        taskId
          ? t("taskManagement.editNewTask")
          : t("taskManagement.addNewTask")
      }
    >
      {otherElements}
    </Page>
  );
};
export default withTranslation()(AddNewNote);
